import { render, staticRenderFns } from "./Initialize.vue?vue&type=template&id=84c6956c&scoped=true"
import script from "./Initialize.vue?vue&type=script&lang=js"
export * from "./Initialize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c6956c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c6956c')) {
      api.createRecord('84c6956c', component.options)
    } else {
      api.reload('84c6956c', component.options)
    }
    module.hot.accept("./Initialize.vue?vue&type=template&id=84c6956c&scoped=true", function () {
      api.rerender('84c6956c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Initialize.vue"
export default component.exports